import { Badge } from '@/components/ui/badge';
import type { WorkOrderStatus, WorkOrderPriority } from '../../types';

interface WorkOrderStatusBadgeProps {
  status: WorkOrderStatus;
}

const statusConfig: Record<WorkOrderStatus, { label: string; className: string }> = {
  draft: { label: 'Draft', className: 'bg-gray-500 hover:bg-gray-600 text-white' },
  pending: { label: 'Pending', className: 'bg-yellow-500 hover:bg-yellow-600 text-black' },
  confirmed: { label: 'Confirmed', className: 'bg-amber-500 hover:bg-amber-600 text-white' },
  in_progress: { label: 'In Progress', className: 'bg-blue-500 hover:bg-blue-600 text-white' },
  picking: { label: 'Picking', className: 'bg-purple-500 hover:bg-purple-600 text-white' },
  packing: { label: 'Packing', className: 'bg-indigo-500 hover:bg-indigo-600 text-white' },
  completed: { label: 'Completed', className: 'bg-green-500 hover:bg-green-600 text-white' },
  cancelled: { label: 'Cancelled', className: 'bg-red-500 hover:bg-red-600 text-white' },
};

export function WorkOrderStatusBadge({ status }: WorkOrderStatusBadgeProps) {
  const config = statusConfig[status] || { label: status, className: 'bg-gray-500' };
  return <Badge className={config.className}>{config.label}</Badge>;
}

interface WorkOrderPriorityBadgeProps {
  priority: WorkOrderPriority;
}

const priorityConfig: Record<WorkOrderPriority, { label: string; className: string }> = {
  low: { label: 'Low', className: 'bg-slate-400 hover:bg-slate-500 text-white' },
  normal: { label: 'Normal', className: 'bg-slate-500 hover:bg-slate-600 text-white' },
  high: { label: 'High', className: 'bg-orange-500 hover:bg-orange-600 text-white' },
  urgent: { label: 'Urgent', className: 'bg-red-600 hover:bg-red-700 text-white' },
};

export function WorkOrderPriorityBadge({ priority }: WorkOrderPriorityBadgeProps) {
  const config = priorityConfig[priority] || { label: priority, className: 'bg-gray-500' };
  return <Badge className={config.className}>{config.label}</Badge>;
}
